import styled from 'styled-components';
import { Typography, TypographyProps } from '@mui/material';
import theme from '../../../styles/theme';

export const StyledError = styled(Typography)`
  color: ${theme.palette.error.main};
`;

export interface IErrorProps extends TypographyProps {
  type?: 'validation' | 'api';
}

const ErrorContainer = styled.div`
  background-color: ${theme.palette.error.light};
  padding: 16px;
  margin-top: 16px;
  width: 100%;
`;

export const BravoError = (props: IErrorProps) => {
  const { type = 'validation' } = props;

  if (type == 'api') {
    return <ErrorContainer>{<StyledError {...props} />}</ErrorContainer>;
  }
  return <StyledError {...props} />;
};
